<!-- Here's the DIV that we inject the map into -->
<div #mapViewNode></div>
